export function debounce(func, delay) {
    let inDebounce
    return function() {
        const context = this
        const args = arguments
        clearTimeout(inDebounce)
        inDebounce = setTimeout(() => func.apply(context, args), delay)
    }
}

export function loader(elm) {
    const loaderHTML = `<div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>`

    elm.insertAdjacentHTML('beforeend', loaderHTML)
}

export function checkClickOutside(element, event, callback) { 
    if (event.target !== element && !element.contains(event.target)) {
        callback()
    }
}

// Function to check if propterties object is empty
// if it is, it means that it's a wrapping product
export function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}


export function setNewCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    var expires = "; expires=" + date.toUTCString();

    document.cookie = name+"="+value+"; " + expires + "; path=/"
}

export function getNewCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function deleteCookie( name ) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}